// Bootstrap
require('./bootstrap');

// Fancybox
require('@fancyapps/fancybox/dist/jquery.fancybox.min');

// Slick carousel
require('slick-carousel/slick/slick');

// Select2
require('select2/dist/js/select2.min');

import flatpickr from "flatpickr";

const slugify = require('slugify');
window.slugify = slugify;

$(document).ready(function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    $('.hamburger').click(function () {
        $(this).toggleClass('is-active');
    });

    flatpickr('.flatpickr', {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
        minDate: "today",
        wrap: true
    });

    flatpickr('.flatpickr--past', {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
        wrap: true
    });

    flatpickr('.flatpickr--object-form', {
        dateFormat: "d-m-Y",
        wrap: true
    });

    let timeout;
    $('.btn--plus, .btn--minus').on('mousedown', function() {
        let input = $(this).closest('.input-group').find('input');
        if ($(this).hasClass('btn--plus')) {
            increase(input);
        }
        if ($(this).hasClass('btn--minus')) {
            decrease(input);
        }
    }).on('mouseup mouseleave', function () {
        stop();
    });

    function increase(input) {
        timeout = setTimeout(() => {
            input.val(parseInt(input.val()) + 1);
            increase(input);
        }, 200);
    }

    function decrease(input) {
        if (input.val() > 0) {
            timeout = setTimeout(() => {
                input.val(parseInt(input.val()) - 1);
                decrease(input);
            }, 200);
        }
    }

    function stop() {
        clearTimeout(timeout);
    }

    $('.collapse-indicators').click(function () {
        $(this).text(function (i, text) {
            console.log(i, text);
            return text === 'Meer informatie' ? 'Inklappen' : 'Meer informatie';
        });
    });

    $('[data-fancybox="gallery"]').fancybox({
        thumbs : {
            autoStart : true
        }
    });
});

// get search parameters
window.getSearchParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    let search = params.get('zoeken');

    if (search) {
        search.replace("%20", " ");
    }

    return search;
}

// get subject parameters
window.getSubjectParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    let subject = params.get('onderwerp');

    if (subject) {
        subject.replace("%20", " ");
    }

    return subject;
}

// get type parameters
window.getTypeParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    let type = params.get('type');

    if (type) {
        type.replace("%20", " ");
    }

    return type;
}

// get name parameters
window.getNameParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    let name = params.get('naam');

    if (name) {
        name.replace("%20", " ");
    }

    return name;
}

// get categories parameters
window.getCategoryParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    return params.get('categorieen');
}

// get location parameters
window.getLocationParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    return params.get('locatie');
}

// get radius parameters
window.getRadiusParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    return params.get('straal');
}

// set search parameters
window.addSearchParameters = function (value) {
    value = value.replace(" ",  "%20");
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    if (getSearchParameters()) {
        params.delete('zoeken');
    }

    if (getSubjectParameters()) {
        window.history.replaceState(null, null, '?zoeken=' + value + '&onderwerp=' + getSubjectParameters());
    } else {
        window.history.replaceState(null, null, '?zoeken=' + value);
    }
}

// set subject parameters
window.addSubjectParameters = function (value) {
    value = value.replace(" ",  "%20");
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    if (getSubjectParameters()) {
        params.delete('onderwerp');
    }

    if (getSearchParameters()) {
        window.history.replaceState(null, null, '?zoeken=' + getSearchParameters() + '&onderwerp=' + value);
    } else {
        window.history.replaceState(null, null, '?onderwerp=' + value);
    }
}

// set subject parameters
window.addTypeParameters = function (value) {
    value = value.replace(" ",  "%20");
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    if (getTypeParameters()) {
        params.delete('type');
    }

    if (getSearchParameters()) {
        window.history.replaceState(null, null, '?zoeken=' + getSearchParameters() + '&type=' + value);
    } else {
        window.history.replaceState(null, null, '?type=' + value);
    }
}

// remove search parameters
window.removeSearchParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    params.delete('zoeken');

    if (getSubjectParameters()) {
        window.history.replaceState(null, null, '?onderwerp=' + getSubjectParameters());
    } else {
        window.history.replaceState(null, null, location.pathname);
    }
}

// remove subject parameters
window.removeSubjectParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    params.delete('onderwerp');

    if (getSearchParameters()) {
        window.history.replaceState(null, null, '?zoeken=' + getSearchParameters());
    } else {
        window.history.replaceState(null, null, location.pathname);
    }
}

// remove subject parameters
window.removeTypeParameters = function () {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    params.delete('type');

    if (getSearchParameters()) {
        window.history.replaceState(null, null, '?zoeken=' + getSearchParameters());
    } else {
        window.history.replaceState(null, null, location.pathname);
    }
}
